var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"header-subtotal"},[_c('h2',{staticClass:"header-subtotal-cart"},[_vm._v("\n\t\tCart\n\t")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }